import React from 'react'
import { Button, Grid, TextField, Typography } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'

// components
import PageTitle from '../../PageTitle/PageTitle'
// data
import { FormLoader } from '../../../Loader/FormLoader'
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl'
import Configuration from '../../../../Services/Api/Configuration'
import UserServices from '../../../../Services/Consumers/UserServices'
import { filterData } from '../../../../utils/helpers'
import {
  exportFiltersPayload,
  UserCompaniesFiltersPayload
} from '../../../../Services/Payloads/AuthenticatedUserPayload'
import { useKeycloak } from '@react-keycloak/web'
import { useStyles } from './Styles'
import DateFilter from '../PaymentClaimsContent/DateFilter'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import moment from 'moment'
import 'moment/locale/ar-ly'
import Moment from 'react-moment'
import PaymentReceiptMenu from './PaymentReceiptMenu'
import PaymentReceiptPDFContent from './PaymentReceiptPDFContent'

let { User_Config } = Configuration
export default function PaymentReceiptsContent ({ handleNotificationCall, locale }) {
  let classes = useStyles()
  const intl = useIntl()
  const { keycloak } = useKeycloak()
  const [count, setCount] = React.useState(0)
  const [currentFilter, setCurrentFilter] = React.useState(null)
  const rowsPerPage = User_Config.userPaymentReceiptsLimit
  const [sortOrder, setSortOrder] = React.useState({})
  const [currentDate, setCurrentDate] = React.useState(new Date())
  const [data, setData] = React.useState(['Loading Data...'])
  const [loadedData, setLoadedData] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  let NumbersRegex = /^[0-9]+$/
  let isFilterValid = {
    tax_id: true,
    request_number: true,
    payment_claim_number: true
  }
  const columns = [
    {
      name: 'id',
      label: intl.formatMessage({ id: 'Users.List.Table.ID' }),
      options: {
        display: 'false',
        filter: false,
        viewColumns: false
      }
    },
    {
      name: 'taxpayer_name',
      label: intl.formatMessage({ id: 'CompanyHeader.TaxpayerName' }),
      options: {
        filter: false
      }
    },
    {
      name: 'tax_id',
      label: intl.formatMessage({ id: 'CompanyHeader.UniqueTaxId' }),
      options: {
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='CompanyHeader.UniqueTaxId'/>:
                <span>{v}</span>
              </div>
            )
          }
        },
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <TextField
              fullWidth
              label={intl.formatMessage({ id: 'CompanyHeader.UniqueTaxId' })}
              id='tax_id'
              name='tax_id'
              value={filterList[index][0] || ''}
              onChange={(event) => {
                filterList[index][0] = event.target.value
                onChange(filterList[index], index, column)
                isFilterValid.tax_id = !(event.target.value && ((event.target.value.length < 9 || event.target.value.length > 10) || !NumbersRegex.test(event.target.value)))
              }}
              helperText={filterList[index][0] &&
              (!NumbersRegex.test(filterList[index][0]) ? intl.formatMessage({ id: 'validationSchema.taxOnlyNumbers' })
                : (((filterList[index][0]).length < 9 || (filterList[index][0]).length > 10) && intl.formatMessage({ id: 'validationSchema.taxLengthMinMax' })))}
              error={(filterList[index][0] && (!NumbersRegex.test(filterList[index][0]) || ((filterList[index][0]).length < 9 || (filterList[index][0]).length > 10)))}
            />
          )
        }
      }
    },
    {
      name: 'name',
      label: intl.formatMessage({ id: 'CompanyHeader.CompanyName' }),
      options: {
        display: 'false',
        filter: false
      }
    },
    {
      name: 'subscription_end_date',
      label: intl.formatMessage({ id: 'CompanyHeader.subscriptionEndDate' }),
      options: {
        display: 'false',
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                         format="Do MMMM YYYY h:mm a">{data[dataIndex].subscription_end_date}</Moment>
        }
      }
    },
    {
      name: 'receipt_number',
      label: intl.formatMessage({ id: 'PaymentHeader.receiptNumber' }),
      options: {
        filterType: 'textField',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='PaymentHeader.receiptNumber'/>:
                <span>{v}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'request_number',
      label: intl.formatMessage({ id: 'PaymentHeader.requestNumber' }),
      options: {
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='PaymentHeader.requestNumber'/>:
                <span>{v}</span>
              </div>
            )
          }
        },
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <TextField
              fullWidth
              label={intl.formatMessage({ id: 'PaymentHeader.requestNumber' })}
              id='request_number'
              name='request_number'
              value={filterList[index][0] || ''}
              onChange={(event) => {
                filterList[index][0] = event.target.value
                onChange(filterList[index], index, column)
                isFilterValid.request_number = !(event.target.value && (event.target.value.length !== 20 || !NumbersRegex.test(event.target.value)))
              }}
              helperText={filterList[index][0] &&
              (!NumbersRegex.test(filterList[index][0]) ? intl.formatMessage({ id: 'validationSchema.requestNumberOnlyNumbers' })
                : ((filterList[index][0]).length !== 20 && intl.formatMessage({ id: 'validationSchema.requestNumberLengthMinMax' })))}
              error={(filterList[index][0] && (!NumbersRegex.test(filterList[index][0]) || (filterList[index][0]).length !== 20))}
            />
          )
        }
      }
    },
    {
      name: 'request_state',
      label: intl.formatMessage({ id: 'PaymentHeader.requestState' }),
      options: {
        filterOptions: {
          names: ['paid_and_waiting_coretaxation_acknowledgment', 'paid'],
          renderValue: (v) => {
            let value = ''
            switch (v) {
              case 'paid_and_waiting_coretaxation_acknowledgment':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.paidAndWaiting' })
                break
              case 'paid':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.paid' })
                break
              default:
                value = ''
            }
            return value
          }
        },
        customFilterListOptions: {
          render: (v) => {
            let value = ''
            switch (v) {
              case 'paid_and_waiting_coretaxation_acknowledgment':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.paidAndWaiting' })
                break
              case 'paid':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.paid' })
                break
              default:
                value = ''
            }
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='PaymentHeader.requestState'/>:
                <span>{value}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'registration_payment_type',
      label: intl.formatMessage({ id: 'PaymentHeader.registrationPaymentType' }),
      options: {
        display: 'false',
        filter: false
      }
    },
    {
      name: 'payment_tax_type',
      label: intl.formatMessage({ id: 'PaymentHeader.climeType' }),
      options: {
        display: 'false',
        filter: false
      }
    },
    {
      name: 'payment_item',
      label: intl.formatMessage({ id: 'PaymentHeader.paymentItem' }),
      options: {
        display: 'false',
        filter: false
      }
    },
    {
      name: 'payment_claim_number',
      label: intl.formatMessage({ id: 'PaymentHeader.climeNumber' }),
      options: {
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='PaymentHeader.climeNumber'/>:
                <span>{v}</span>
              </div>
            )
          }
        },
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <TextField
              fullWidth
              label={intl.formatMessage({ id: 'PaymentHeader.climeNumber' })}
              id='payment_claim_number'
              name='payment_claim_number'
              value={filterList[index][0] || ''}
              onChange={(event) => {
                filterList[index][0] = event.target.value
                onChange(filterList[index], index, column)
                isFilterValid.payment_claim_number = !(event.target.value && !NumbersRegex.test(event.target.value))
              }}
              helperText={filterList[index][0] && !NumbersRegex.test(filterList[index][0]) && intl.formatMessage({ id: 'validationSchema.climeNumberOnlyNumbers' })}
              error={(filterList[index][0] && !NumbersRegex.test(filterList[index][0]))}
            />
          )
        }
      }
    },
    {
      name: 'payment_claim_amount',
      label: intl.formatMessage({ id: 'PaymentHeader.climeAmount' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return <FormattedNumber value={data[dataIndex].payment_claim_amount}/>
        }

      }
    },
    {
      name: 'currency',
      label: intl.formatMessage({ id: 'PaymentHeader.currency' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            !!data[dataIndex].currency?.name ?
            <span>
              {data[dataIndex].currency?.name} <strong>({data[dataIndex].currency?.key?.toUpperCase()})</strong>
            </span>
            :
            '—'
          )
        }
      } 
    },
    {
      name: 'payment_type',
      label: intl.formatMessage({ id: 'PaymentHeader.paymentType' }),
      options: {
        display: 'false',
        filterOptions: {
          names: ['core_payment', 'none_core_payment', 'down_payment'],
          renderValue: (v) => {
            let value = ''
            switch (v) {
              case 'core_payment':
                value = intl.formatMessage({ id: 'PaymentHeader.paymentType.core_payment' })
                break
              case 'none_core_payment':
                value = intl.formatMessage({ id: 'PaymentHeader.paymentType.none_core_payment' })
                break
              case 'down_payment':
                value = intl.formatMessage({ id: 'PaymentHeader.paymentType.down_payment' })
                break
              default:
                value = ''
            }
            return value
          }
        },
        customFilterListOptions: {
          render: (v) => {
            let value = ''
            switch (v) {
              case 'core_payment':
                value = intl.formatMessage({ id: 'PaymentHeader.paymentType.core_payment' })
                break
              case 'none_core_payment':
                value = intl.formatMessage({ id: 'PaymentHeader.paymentType.none_core_payment' })
                break
              case 'down_payment':
                value = intl.formatMessage({ id: 'PaymentHeader.paymentType.down_payment' })
                break
              default:
                value = ''
            }
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='PaymentHeader.paymentType'/>:
                <span>{value}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'payment_tax_period_from',
      label: intl.formatMessage({ id: 'PaymentHeader.taxPeriodFrom' }),
      options: {
        display: 'false',
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                         format="Do MMMM YYYY h:mm a">{data[dataIndex].payment_tax_period_from}</Moment>
        }
      }
    },
    {
      name: 'payment_tax_period_to',
      label: intl.formatMessage({ id: 'PaymentHeader.taxPeriodTo' }),
      options: {
        display: 'false',
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                         format="Do MMMM YYYY h:mm a">{data[dataIndex].payment_tax_period_to}</Moment>
        }
      }
    },
    {
      name: 'payment_claim_expire_date',
      label: intl.formatMessage({ id: 'PaymentHeader.climeExpireDate' }),
      options: {
        display: 'false',
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                         format="Do MMMM YYYY h:mm a">{data[dataIndex].payment_claim_expire_date}</Moment>
        }
      }
    },
    {
      name: 'request_created_at',
      label: intl.formatMessage({ id: 'PaymentHeader.requestCreatedDate' }),
      options: {
        display: 'false',
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                         format="Do MMMM YYYY h:mm a">{data[dataIndex].request_created_at}</Moment>
        }
      }
    },
    {
      name: 'expire_date',
      label: intl.formatMessage({ id: 'PaymentHeader.requestExpireDate' }),
      options: {
        display: 'false',
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                         format="Do MMMM YYYY h:mm a">{data[dataIndex].expire_date}</Moment>
        }
      }
    },
    {
      name: 'create_at',
      label: intl.formatMessage({ id: 'PaymentHeader.createDate' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                         format="Do MMMM YYYY h:mm a">{data[dataIndex].create_at}</Moment>
        }
      }
    },
    {
      name: 'created_from_datetime',
      options: {
        display: 'false',
        viewColumns: false,
        filter: true,
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.dateChip}>
                <FormattedMessage id='Fields.placeholder.dateFrom'/>:
                <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY, h:mm a">{v[0]}</Moment>
              </div>
            )
          }
        },
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <DateFilter
              filterList={filterList}
              onChange={onChange}
              index={index}
              type={'datetime-local'}
              column={column}
              id="created_from_datetime"
              label={intl.formatMessage({ id: 'Fields.placeholder.dateFrom' })}
            />
          )
        }
      }
    },
    {
      name: 'created_to_datetime',
      options: {
        display: 'false',
        viewColumns: false,
        filter: true,
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.dateChip}>
                <FormattedMessage id='Fields.placeholder.dateTo'/>:
                <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY, h:mm a">{v[0]}</Moment>
              </div>
            )
          }
        },
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <DateFilter
              filterList={filterList}
              onChange={onChange}
              index={index}
              type={'datetime-local'}
              column={column}
              id="created_to_datetime"
              label={intl.formatMessage({ id: 'Fields.placeholder.dateTo' })}
            />
          )
        }
      }
    },
    {
      name: '',
      options: {
        filter: false,
        print: false,
        viewColumns: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          return (<PaymentReceiptMenu receiptNumber={data[dataIndex].receipt_number} setCurrentDate={setCurrentDate}/>)
        }
      }
    }
  ]
// get data
  const getUsersListData = async (page) => {
    await xhrRequest(page)
  }
  // mock async function
  const xhrRequest = (page, sortOrder = {}, clear) => {
    if (!!keycloak?.authenticated) {
      setIsLoading(true)
      if (!!loadedData[page] && !!loadedData[page].length && !clear) {
        setData(loadedData[page])
        setIsLoading(false)
      } else {
        UserServices.getPaymentReceipts({
          headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
          params: filterData(UserCompaniesFiltersPayload(page, rowsPerPage, currentFilter))
        }).then((result) => {
          if ((!!result.response && result.response.status !== 200) || !result) {

            let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })
            if (result.response.data && result.response.data.status) {
              if (result.response.status === 403) {
                setData([])
                message = intl.formatMessage({ id: 'BasicInfo.AccessDeniedAlert' })
              } else if (result.response.data.status.errors && result.response.status === 422) {
                message = result.response.data.status.errors
              } else if (result.response.data.status.message) {
                message = result.response.data.status.message
              }
            }
            handleNotificationCall({
              type: 'defence',
              message: message,
              color: 'error'
            }, 'error')
          } else {
            if (!!result && !!result.data && !!result.data.data) {
              let newData = []
              result.data.data.forEach((receipt) => {
                newData.push({
                  id: receipt.id,
                  create_at: receipt.create_at,
                  receipt_number: receipt.receipt_number,
                  taxpayer_name: receipt.payment_request.company.taxpayer_name,
                  tax_id: receipt.payment_request.company.tax_id,
                  name: receipt.payment_request.company.name,
                  subscription_end_date: receipt.payment_request.company.subscription_end_date,
                  request_created_at: receipt.payment_request.created_at,
                  expire_date: receipt.payment_request.expire_date,
                  payment_claim_amount: receipt.payment_request.payment_claim_amount,
                  payment_claim_expire_date: receipt.payment_request.payment_claim_expire_date,
                  payment_claim_number: receipt.payment_request.payment_claim_number,
                  payment_tax_type: receipt.payment_request.payment_tax_type,
                  payment_item: receipt.payment_request.payment_item,
                  payment_tax_period_from: receipt.payment_request.payment_tax_period_from,
                  payment_tax_period_to: receipt.payment_request.payment_tax_period_to,
                  payment_type: receipt.payment_request.payment_type,
                  registration_payment_type: receipt.payment_request.registration_payment_type,
                  request_number: receipt.payment_request.request_number,
                  request_state: receipt.payment_request.request_state,
                  currency: receipt.payment_request.currency
                })
              })
              setSortOrder(sortOrder)
              let sortField = sortOrder.name
              let sortDir = sortOrder.direction

              if (sortField) {
                newData = newData.sort((a, b) => {
                  if (a[sortField] < b[sortField]) {
                    return 1 * (sortDir === 'asc' ? -1 : 1)
                  } else if (a[sortField] > b[sortField]) {
                    return -1 * (sortDir === 'asc' ? -1 : 1)
                  } else {
                    return 0
                  }
                })
              }
              setData(newData)
              let prevData = loadedData
              prevData[page] = newData
              setLoadedData(prevData)
              setCount(result.data.meta.total)
            }
          }
        }).then(() => {
          setIsLoading(false)
        })
      }
    }
  }
  const sort = (page, sortOrder) => {
    setSortOrder(sortOrder)
    let sortField = sortOrder.name
    let sortDir = sortOrder.direction
    let newData = data

    if (sortField) {
      newData = newData.sort((a, b) => {
        if (a[sortField] < b[sortField]) {
          return 1 * (sortDir === 'asc' ? -1 : 1)
        } else if (a[sortField] > b[sortField]) {
          return -1 * (sortDir === 'asc' ? -1 : 1)
        } else {
          return 0
        }
      })
    }
    setData(newData)
    // xhrRequest(page, sortOrder)
  }
  React.useEffect(() => {
      getUsersListData(1)
    },// eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const changePage = (page, sortOrder) => {
    xhrRequest(++page, sortOrder)
  }
  const changeFilter = (applyFilters) => {
    setLoadedData([])
    let filterList = applyFilters()
    let filters = {}
    filterList.forEach((filterItem, index) => {
      if (!!filterItem.length) {
        if ('created_from_datetime' === columns[index].name || 'created_to_datetime' === columns[index].name) {
          filters[columns[index].name] = moment(filterItem[0]).utc().format('DD-MM-YYYY HH:mm:ss')
        } else if (filterItem[0].length >= 1) {
          filters[columns[index].name] = filterItem[0]
        }
      }
    })
    setCurrentFilter(filters)
  }
  React.useEffect(() => {
      if (!!currentFilter) {
        xhrRequest(1, {}, true)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentFilter])

  const options = {
    filter: true,
    filterType: 'dropdown',
    responsive: 'simple',
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    serverSide: true,
    count: count,
    search: false,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [],
    sortOrder: sortOrder,
    confirmFilters: true,
    onDownload: (buildHead, buildBody, columns, data) => {
      UserServices.exportPaymentReceipts({
        headers: {
          'Authorization': `Bearer ${keycloak?.token ?? ''}`,
          'Accept': 'application/octet-stream'
        },
        params: filterData(exportFiltersPayload(currentFilter)),
        responseType: 'blob'
      }).then((result) => {
        if (result.data) {
          const type = result.headers['content-type']
          const blob = new Blob([result.data], { type: type, encoding: 'UTF-8' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          const contentDisposition = result.headers['content-disposition']
          let fileName = `${intl.formatMessage({ id: 'PaymentsContent.ActionLinks.PaymentReceipts' })}.xlsx`
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch.length === 2)
              fileName = fileNameMatch[1]
          }
          link.setAttribute('download', fileName) //or any other extension
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        }
      })
      return false
    },
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div className={classes.ApplyFilterWrapper}>
          <Button color='primary' variant="contained"
                  disabled={!(isFilterValid.tax_id && isFilterValid.request_number && isFilterValid.payment_claim_number)}
                  onClick={() => changeFilter(applyNewFilters)}>
            <FormattedMessage id='Users.List.Table.ApplyFilters'/></Button>
        </div>
      )
    },
    onFilterChange: (column, filterList, type) => {
      if (type === 'chip' ||
        (typeof column === 'string' && typeof type === 'string' && type === 'custom'
          && (column === 'created_from_datetime' || column === 'created_to_datetime' || column === 'tax_id' ||
            column === 'request_number' || column === 'payment_claim_number'))) {
        let newFilters = () => (filterList)
        console.log('updating filters via chip')
        changeFilter(newFilters)
      }
    },
    textLabels: {
      body: {
        noMatch: intl.formatMessage({ id: 'PaymentReceipts.List.Table.NoMatching' }),
        toolTip: intl.formatMessage({ id: 'Users.List.Table.Sort' }),
        columnHeaderTooltip: column => intl.formatMessage(
          { id: 'Users.List.Table.SortFor' },
          { label: column.label })
      },
      pagination: {
        next: intl.formatMessage({ id: 'Users.List.Table.NextPage' }),
        previous: intl.formatMessage({ id: 'Users.List.Table.PreviousPage' }),
        rowsPerPage: intl.formatMessage({ id: 'Users.List.Table.RowsPerPage' }),
        displayRows: intl.formatMessage({ id: 'Users.List.Table.Of' })
      },
      toolbar: {
        search: intl.formatMessage({ id: 'Users.List.Table.Search' }),
        downloadCsv: intl.formatMessage({ id: 'PaymentRequests.List.Table.Download' }),
        print: intl.formatMessage({ id: 'Users.List.Table.Print' }),
        viewColumns: intl.formatMessage({ id: 'Users.List.Table.ViewColumns' }),
        filterTable: intl.formatMessage({ id: 'Users.List.Table.FilterTable' })
      },
      filter: {
        all: intl.formatMessage({ id: 'Users.List.Table.All' }),
        title: intl.formatMessage({ id: 'Users.List.Table.FILTERS' }),
        reset: intl.formatMessage({ id: 'Users.List.Table.RESET' })
      },
      viewColumns: {
        title: intl.formatMessage({ id: 'Users.List.Table.ShowColumns' }),
        titleAria: intl.formatMessage({ id: 'Users.List.Table.ShowHideColumns' })
      }
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          changePage(tableState.page, tableState.sortOrder)
          break
        case 'sort':
          sort(tableState.page, tableState.sortOrder)
          break
        default:
          break
      }
    }
  }
  return (
    <AuthenticatedUserConsumer>
      {({ userData }) => (
        <>
          <PageTitle title={<FormattedMessage id='PaymentsContent.ActionLinks.PaymentReceipts'/>}/>
          <Grid container spacing={4}>
            <Grid item xs={12} className={classes.TableWrapper}>
              {isLoading && <FormLoader loading={true}/>}
              {!!data && !!data.length && data.map((receipt, index) => (
                <PaymentReceiptPDFContent key={index}
                                          receiptDetails={receipt}
                                          locale={locale}
                                          userName={userData.first_name + ' ' + userData.last_name}
                                          currentDate={currentDate}/>
              ))}
              <MUIDataTable
                title={
                  <Typography variant="h6">
                    <FormattedMessage id='PaymentsContent.ActionLinks.PaymentReceipts'/>
                  </Typography>
                }
                data={data}
                columns={columns}
                options={options}
              />
            </Grid>
          </Grid>
        </>
      )}
    </AuthenticatedUserConsumer>
  )
}
